import { render, staticRenderFns } from "./BuroForm.vue?vue&type=template&id=b09412d2&scoped=true"
import script from "./BuroForm.vue?vue&type=script&lang=ts"
export * from "./BuroForm.vue?vue&type=script&lang=ts"
import style0 from "./BuroForm.vue?vue&type=style&index=0&id=b09412d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09412d2",
  null
  
)

export default component.exports